import React, { useState, useEffect } from 'react'
import InventoryForm from "./InventoryForm";
import { Column, Row } from 'simple-flexbox';
import { Paper, makeStyles, TableBody, TableRow, TableCell, Toolbar, InputAdornment } from '@material-ui/core';
import useTable from "../../../utilities/useTable";
import { store } from '../../../../redux-store/store';
import { ToastContainer } from 'react-toastify';
import StatComponent from '../../stat-page/StatComponent';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from "react-redux";
import { request } from '../../../../api/Service'
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from '@material-ui/icons/Add';
import Popup from "../../../utilities/Popup";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import Moment from 'react-moment';
import CloseIcon from '@material-ui/icons/Close';
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddInventoryForm from './AddInventoryForm';

const useStyles = makeStyles(theme => ({
    pageContent: {
        margin: theme.spacing(1),
        padding: theme.spacing(3)
    },
    searchInput: {
        width: '75%'
    },
    newButton: {
        position: 'absolute',
        right: '10px'
    }
}))


const headCells = [
    { id: 'isActive', label: 'Product Name' },
    { id: 'contactName', label: 'Sales Price' },
    { id: 'locationName', label: 'Recieving Location' },
    { id: 'locationAddress', label: 'Quantity Removed' },
    { id: 'dateRemoved', label: 'Date Removed' },
    { id: 'mode', label: 'Mode' },
]

export function OutGoingInventory({ outgoingInventory }) {

    const classes = useStyles();
    const [recordForEdit, setRecordForEdit] = useState(null)
    const [inventories, setInventories] = useState([])
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [openPopup, setOpenPopup] = useState(false)
    const [addOpenPopup, setAddOpenPopup] = useState(false)
    const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(inventories, headCells, filterFn);

    useEffect(() => {
        store.dispatch({ type: "DISPLAY_LOADER" })
        request('get', {}, `get-outgoing-inventory`).then(data => {
            setInventories(data)
            store.dispatch({ type: "DISPLAY_LOADER" })
        }
        )
        return () => {

        }
    }, [])

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {

                if (target.value === "")
                    return items;
                else
                    return items.filter(x => x.firstName.toLowerCase().includes(target.value))
            }
        })
    }

    const addOrEdit = (inventory, resetForm) => {
        if (inventory.id === 0)
            //  AddInventory(inventory)
            // else
            var data = { ...inventory }
        // AddInventory(data)
        resetForm()
        setOpenPopup(false)
        setAddOpenPopup(false)
    }




    const addInventory = (inventory, resetForm) => {
        // AddInventory(inventory)
        resetForm()
        setRecordForEdit(null)
        setOpenPopup(false)
        setAddOpenPopup(false)
    }

    const openInPopup = item => {
        setRecordForEdit(item)
        setOpenPopup(true)
    }

    const onDelete = id => {
        //   DeleteLocation(id)
        setConfirmDialog({
            ...confirmDialog,
            isOpen: false
        })
    }
    return (
        <>
            <div className="container" style={{}}>
                <div style={{}}>
                    <Column flexGrow={1}>
                        <ToastContainer />
                        <div className="mb-2" style={{ position: "relative" }}>
                            <Controls.Input
                                // label="Search Inventories"
                                placeholder="Search Inventories"
                                className={classes.searchInput}
                                InputProps={{
                                    startAdornment: (<InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>)
                                }}
                                onChange={handleSearch}
                            />
                        </div>

                        <Paper className={classes.pageContent}>
                            <h4> <strong>Outgoing </strong> </h4>
                            <TblContainer>
                                <TblHead />
                                <TableBody>
                                    {

                                        recordsAfterPagingAndSorting().map(item =>
                                        (<TableRow key={item.dateRemoved}>
                                            <TableCell>{item.productName}</TableCell>
                                            <TableCell>{item.salesPrice}</TableCell>
                                            <TableCell>{item.locationName}</TableCell>
                                            <TableCell>{item.quantityRemoved}</TableCell>
                                            <TableCell><Moment format="YYYY/MM/DD:HH:MM:SS">{item.dateRemoved}</Moment></TableCell>
                                            <TableCell>{item.mode}</TableCell>
                                        </TableRow>)
                                        )
                                    }
                                </TableBody>
                            </TblContainer>
                            <TblPagination />
                        </Paper>
                        <Popup
                            title=" Inventory Form"
                            openPopup={openPopup}
                            setOpenPopup={setOpenPopup}
                        >
                        </Popup>

                        <Popup
                            title="Add Inventory Form"
                            openPopup={addOpenPopup}
                            setOpenPopup={setAddOpenPopup}
                        >


                        </Popup>
                        <Notification
                            notify={notify}
                            setNotify={setNotify}
                        />
                        <ConfirmDialog
                            confirmDialog={confirmDialog}
                            setConfirmDialog={setConfirmDialog}
                        />
                    </Column>
                </div>
            </div>
        </>

    )
}





function mapStateToProps(state) {

    return {


        incomingInventory: state.inventoryReducer.incomingInventory
    };
}
const mapDispatchToProps = (dispatch) => ({

    LoadIncomingInventory() {
        dispatch({ type: "LOAD_INCOMING_INVENTORY" });
    },

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OutGoingInventory);